module.exports = __webpack_public_path__ + "2812b016f4a3b0d6696f3db5cf8d723b.svg";